import GetFiveAccomplishments from 'builder/components/GetFiveAccomplishments'

const SevenStoriesView = () => {
  return <GetFiveAccomplishments />
}

export default SevenStoriesView
